import React from 'react';
import { Autocomplete, InputAdornment } from "@mui/material";
import { DropdownArrowIcon } from "./SelectStyles";
import { ChevronDown, ColorSAP, FONT_FAMILY } from "../../ontego-ui";
import Styled from '../Form/FormStyles';
import Typography from '../../ontego-ui/components/Typography';

export const Select = (props) => {
    const { label, required, value, onChange, placeholder, options, error } = props;

    return (
        <div>
            {label && 
                <Typography
                    fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_SEMIBOLD}
                    size={14}
                    color={error ? ColorSAP.danger[60] : ColorSAP.neutral[100]}
                    style={{ marginBottom: 12, lineHeight: "17px" }}
                >
                    {label}{required ? "*" : ""}
                </Typography>
            }
            <Autocomplete
                options={options}
                getOptionLabel={(option) => option.label}
                onChange={onChange}
                value={value}
                renderInput={(params) => {
                    const {disabled, fullWidth, inputProps, size} = params;

                    return(
                        <div style={{ position: "relative", display: "flex", alignItems: "center" }} ref={params.InputProps.ref} onMouseDown={params.inputProps.onMouseDown}>
                            <Styled.CustomOutlinedInput
                                disabled={disabled}
                                fullWidth={fullWidth}
                                inputProps={inputProps}
                                size={size}
                                placeholder={placeholder}
                                error={error}
                                endAdornment={
                                    <InputAdornment position='end'>
                                        <DropdownArrowIcon>
                                            <ChevronDown />
                                        </DropdownArrowIcon>
                                    </InputAdornment>
                                }
                            />
                        </div>
                    )
                }}
            />
        </div>
    );
};

export default React.memo(Select);
